<div
  class="timeline"
  [class.timeline-disabled]="disabled()"
  [class.timeline-create-disabled]="!allowCreate() && !disabled()"
  [style.--scale-hours]="scaleHours()"
>
  <div
    #track
    class="timeline-track"
    (mousemove)="onTrackMouseMove($event)"
    (mouseleave)="onTrackLeave()"
    (click)="onTrackClick($event)"
  >
    <div
      class="timeline-quarter-grid"
      aria-hidden="true"
      [style.--quarter-count]="quarterSlotCount()"
    ></div>

    <ng-template
      #entryTooltip
      let-project="project"
      let-category="category"
      let-description="description"
      let-duration="duration"
      let-approved="approved"
    >
      <div class="timeline-entry-tooltip-content">
        <strong>{{ project }}</strong>
        <span>{{ category }}</span>
        <span>{{ description }}</span>
        <span>{{ duration }}</span>
        @if (approved) {
          <span class="timeline-entry-tooltip-approved">
            <i class="bi bi-lock-fill" aria-hidden="true"></i>
            Approved
          </span>
        }
      </div>
    </ng-template>

    @for (segment of segments(); track segment.entry.id) {
      <button
        type="button"
        class="timeline-block"
        [class.timeline-block-compact]="!segment.showInlineDetail"
        [class.timeline-block-quarter]="segment.isQuarterHourBlock"
        [style.left.%]="segment.leftPercent"
        [style.width.%]="segment.widthPercent"
        [style.background-color]="segment.backgroundColor"
        [class.timeline-block-disabled]="disabled() || segment.locked"
        [class.timeline-block-approved]="segment.locked"
        [attr.aria-disabled]="disabled() || segment.locked || null"
        [ngbTooltip]="entryTooltip"
        [tooltipContext]="segment.tooltipContext"
        tooltipClass="timeline-entry-tooltip"
        container="body"
        triggers="hover focus"
        (click)="onBlockClick(segment.entry, $event)"
      >
        @if (segment.showInlineDetail) {
          <span class="timeline-block-name">{{ segment.label }}</span>
        }
        <span class="timeline-block-hours">{{ segment.durationLabel }}</span>
      </button>
    }

    @if (previewWidthPercent()) {
      <div
        class="timeline-preview timeline-block"
        [class.timeline-block-quarter]="previewIsQuarterHourBlock()"
        [class.timeline-preview-from-start]="!loggedHours()"
        [class.timeline-preview-after-logged]="loggedHours() > 0"
        [style.left.%]="previewLeftPercent()"
        [style.width.%]="previewWidthPercent()"
        [style.background-color]="previewBackgroundColor()"
        aria-hidden="true"
      >
        <span class="timeline-block-hours">{{ previewDurationLabel() }}</span>
      </div>
    }
  </div>

  <div class="timeline-ruler-footer" aria-hidden="true">
    @for (hour of hourMarkers(); track hour) {
      <span class="ruler-hour" [style.--hour]="hour">{{ hour }}</span>
    }
  </div>
</div>
